interface TickerProps {
  items?: string[];
}

const DEFAULT_ITEMS = [
  "COMEDK UGET 2026 registration open · Last date 16 March · Exam 9 May 2026",
  "BIET 2026 batch · 53 TCS offers including 2 Prime (₹9.09 LPA) and 6 Digital (₹7.09 LPA)",
  "BIET attains Autonomous status · NAAC 'A' grade · NBA accredited · UGC 2(f) and 12(B)",
  "STEMIFY 1.0 — Igniting innovation for first-year students · 2025-26",
  "Two first-year CSE students awarded the IEEE WIE Adoption Scholarship 2025-26",
];

export function Ticker({ items = DEFAULT_ITEMS }: TickerProps) {
  const all = [...items, ...items];
  return (
    <div className="ticker">
      <div className="ticker-track">
        {all.map((t, i) => (
          <span key={i} className="ticker-item">
            <span className="dot"></span>
            <span>{t}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
